import { Component, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { StorageService } from '../../services/storage-service';
import { TranslateModule } from '../../shareds/translate/translate.module';
import { LanguageSwitcher } from '../../shareds/translate/language-switcher';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule, LanguageSwitcher],
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  private http = inject(HttpClient);
  private st = inject(StorageService);

  profile = signal<any>(null);
  loading = signal(true);
  editMode = signal(false);
  saving = signal(false);
  saveError = signal('');

  editForm = {
    firstname: '',
    lastname: '',
    phoneCode: '',
    phoneNumber: '',
  };

  ngOnInit() {
    this.getItems();
  }

  getItems() {
    this.http.get<any>('/api/Public/AuthHotel').subscribe({
      next: (res) => {
        const data = res?.data ?? res ?? null;
        this.profile.set(data);
        this.loading.set(false);
      },
      error: () => {
        const ci = this.st.getSession('customerInfo');
        if (ci) this.profile.set(JSON.parse(ci));
        this.loading.set(false);
      }
    });
  }

  getName() {
    const p = this.profile();
    if (p?.firstname || p?.lastname) return `${p?.firstname ?? ''} ${p?.lastname ?? ''}`.trim();
    return p?.name ?? p?.fullName ?? '';
  }
  getEmail() { const p = this.profile(); return p?.username ?? p?.email ?? ''; }
  getPhone() { const p = this.profile(); return p?.phoneNumber ?? p?.phone ?? p?.mobile ?? ''; }
  getAvatar() { const p = this.profile(); return p?.avatarUrl ?? p?.profileImage ?? p?.imageUrl ?? ''; }
  isEmailVerified() { const p = this.profile(); return p?.emailVerified ?? p?.isEmailVerified ?? false; }

  startEdit() {
    const p = this.profile();
    this.editForm = {
      firstname: p?.firstname ?? '',
      lastname: p?.lastname ?? '',
      phoneCode: p?.phoneCode ?? '+66',
      phoneNumber: p?.phoneNumber ?? p?.phone ?? '',
    };
    this.saveError.set('');
    this.editMode.set(true);
  }

  cancelEdit() {
    this.editMode.set(false);
    this.saveError.set('');
  }

  saveProfile() {
    this.saving.set(true);
    this.saveError.set('');
    this.http.put<any>('/api/Public/AuthHotel/Profile', this.editForm).subscribe({
      next: (res) => {
        const updated = res?.data ?? res ?? null;
        if (updated) this.profile.set(updated);
        else this.profile.update(p => ({ ...p, ...this.editForm }));
        this.saving.set(false);
        this.editMode.set(false);
        this.getItems();
      },
      error: (err) => {
        this.saveError.set(err?.error?.message ?? 'เกิดข้อผิดพลาด กรุณาลองใหม่'); // แปลใน template (module 'api')
        this.saving.set(false);
      }
    });
  }

  toBack() {
    history.back();
  }

  logout() {
    this.st.clearTokens();
    history.back();
  }
}
